import type { HistorySearchItem, SuggestResponse } from "../types/suggestion";

/*                                                         */
/*         */
import { headlineTemplate, keywordsTemplate } from "./emptyState.templates";

import { EmptyStateTime, SuggestRenderTime } from "../times";
import { CookieBanner } from "../helper";
import { SELECTOR } from "../types/element/constants";
import { Queue } from "../suggest/PromiseQueue";
import { FTNavEvents } from "../types/ftnav";
import { FTNAV_EVENT } from "../types/ftnav/constants";
import { navSlider } from "../ftnav/NavSlider";

const Mustache = window.Mustache;
const templateString = `<div class="squirrel_searchSuggestions pl_table-view"><span class="js_squirrel_history_layer">{{>historyTemplate}} </span>{{>headlineTemplate}}<ul class="squirrel_searchSuggestions__list">{{>keywordTemplate}}{{>footerLiTemplate}}</ul></div>`;
export class EmptyStateSuggest {
  private suggestLayer: HTMLDivElement;
  private searchField: HTMLInputElement;
  private searchForm: HTMLFormElement;

  constructor() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  init() {
    this.suggestLayer = document.querySelector(SELECTOR.LAYER) as HTMLDivElement;
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchForm = document.querySelector(SELECTOR.SEARCH_FORM) as HTMLFormElement;
  }

  show(callback: () => void = () => {}) {
    EmptyStateTime.reset();

    Queue.enqueue(() =>
      this.retrieveEmptyState()
        .then(this.renderEmptyState.bind(this))
        .then(() => {
          /*                    */
          if (window.o_squirrel.searchSuggest.getSendTrackingLabelOnFocus()) {
            window.o_global.events<FTNavEvents>().emit(FTNAV_EVENT.REGISTER_SLIDER, SELECTOR.NAV_SLIDER_WRAPPER);
            window.o_global.events<FTNavEvents>().once(FTNAV_EVENT.REGISTERED_SLIDER, (id) => {
              id === SELECTOR.NAV_SLIDER_WRAPPER && callback();
            });
          }
        })
        .then(() => {
          window.o_squirrel.searchSuggest.setSuggest(-1);
        })
        .then(window.o_squirrel.searchSuggest.showLayer)
        .then(window.o_squirrel.searchSuggest.scrollToSearchField)
        .catch(window.o_squirrel.searchSuggest.handleError),
    );
  }

  private renderKeywordTemplate(suggestions: SuggestResponse): string {
    const keywords = suggestions.keywords;
    return Mustache.render(keywordsTemplate, {
      original: suggestions.original,
      keywords,
      suggestPos: suggestions.suggestPos,
    });
  }

  renderEmptyState(results: SuggestResponse | Error | string) {
    const historyIsEmpty = window.o_squirrel.submitHistory.isEmpty();
    const suggestions: SuggestResponse = results as SuggestResponse;
    const historyTemplate: string = this.renderHistoryTemplate();
    let renderedTemplate: string;
    if (historyIsEmpty) {
      renderedTemplate = Mustache.render(
        templateString,
        {},
        {
          headlineTemplate,
          keywordTemplate: this.renderKeywordTemplate(suggestions),
        },
      );
    } else {
      renderedTemplate = Mustache.render(
        templateString,
        {},
        {
          historyTemplate,
        },
      );
    }
    SuggestRenderTime.measure();
    this.suggestLayer.innerHTML = renderedTemplate;
    (document.querySelector(".squirrel_searchSuggestions") as HTMLDivElement).prepend(navSlider.template);
  }

  retrieveEmptyState(): Promise<SuggestResponse | Error | string> {
    return window.o_squirrel.searchSuggest
      .fetchSuggestions("", 0, {})
      .then(window.o_squirrel.searchSuggest.extractSuggestions)
      .then(window.o_squirrel.searchSuggest.updateSearchFieldTarget);
  }

  private renderHistoryTemplate() {
    if (CookieBanner.isEnabled() && !window.o_squirrel.submitHistory.isEmpty()) {
      const response: HistorySearchItem[] = window.o_squirrel.submitHistory.retrieveViewedSearch().slice().reverse();
      return window.o_squirrel.searchHistory.renderHistory(response);
    } else {
      return "";
    }
  }
}

const instance = new EmptyStateSuggest();
export const emptyStateSuggest = {
  init: instance.init.bind(instance),
  show: instance.show.bind(instance),
};
